export const isOnline = () => (
    typeof navigator === 'undefined' ? true : navigator.onLine
);

export const getStatus = async () => ({ connected: isOnline() });

export const onChange = (callback) => {
    if (typeof window === 'undefined') return () => {};

    const handleOnline = () => callback({ connected: true });
    const handleOffline = () => callback({ connected: false });

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
    };
};
